import { Button, Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { MuiOtpInput } from "mui-one-time-password-input";

export default function OtpComp({
  setShowOtpComp,
  showotp,
  otp,
  setOtp,
  handleOtpChange,
  errors,
  handleSubmitData,
  mobile,
  title,
  isdCode
}) {
  const handleClick = () => {
    setOtp(null);
    setShowOtpComp(false);
  };
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            textAlign="center"
            sx={{ fontSize: "18px", fontWeight: 600, color: "black" }}
          >
            Please enter the OTP sent to <br /> +{isdCode}{mobile}.{" "}
            <span
              style={{ color: "#2874F0", cursor: "pointer" }}
              onClick={handleClick}
            >
              Change
            </span>
          </Typography>
        </Grid>
        {showotp && (
          <Grid item xs={12} mt={3}>
            <Typography textAlign="left" sx={{ fontWeight: 600 }}>
              OTP
              <span
                style={{
                  color: "red",
                  position: "absolute",
                  marginLeft: "4px",
                  fontSize: "1em",
                }}
              >
                *
              </span>
            </Typography>

            <TextField
              type="number"
              value={otp}
              onChange={handleOtpChange}
              fullWidth
              size="small"
              InputProps={{ style: { borderRadius: "15px" } }}
              error={errors.otp}
              helperText={errors.otp && "OTP is required"}
            />
          </Grid>
        )}

        <Grid item xs={12} mt={3}>
          <Button
            variant="contained"
            color="secondary"
            style={{
              fontSize: "14px",
              width: "100%",
              borderRadius: "10px",
              background: "#019E6F",
              color: "white",
            }}
            // disabled={otp === null || otp === ""}
            onClick={handleSubmitData}
          >
            {title}
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
